var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MUTUAL_FUNDS_TRANSFER_IN, MUTUAL_FUNDS_TRANSFER_IN_CLEAR_ALL_FILTERS, MUTUAL_FUNDS_TRANSFER_IN_ERROR, MUTUAL_FUNDS_TRANSFER_IN_HIDE_ERROR, MUTUAL_FUNDS_TRANSFER_IN_RESET_ALL_FILTERS_AND_SEARCH, MUTUAL_FUNDS_TRANSFER_IN_TABLE_START_LOADER, MUTUAL_FUNDS_TRANSFER_IN_TABLE_STOP_LOADER, MUTUAL_FUNDS_TRANSFER_IN_UPDATE_FILTERS, } from "../interface/IOrderbookTransferIn";
export var transferInInitialData = {
    transferInData: undefined,
    errorData: {
        error: undefined,
        isOpen: false,
    },
    mutualFundTransferInTableShimmer: false,
    appliedFilters: {
        orderBookStatus: [],
    },
};
var mutualFundsTransferInReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = JSON.parse(JSON.stringify(transferInInitialData)); }
    switch (action.type) {
        case MUTUAL_FUNDS_TRANSFER_IN:
            return __assign(__assign({}, state), { transferInData: (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.transferInData });
        case MUTUAL_FUNDS_TRANSFER_IN_ERROR:
            return __assign(__assign({}, state), { 
                // ...transferInInitialData
                transferInData: undefined, mutualFundTransferInTableShimmer: false, errorData: action.payload.errorData });
        case MUTUAL_FUNDS_TRANSFER_IN_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: transferInInitialData.errorData });
        case MUTUAL_FUNDS_TRANSFER_IN_TABLE_START_LOADER:
            return __assign(__assign({}, state), { mutualFundTransferInTableShimmer: true });
        case MUTUAL_FUNDS_TRANSFER_IN_TABLE_STOP_LOADER:
            return __assign(__assign({}, state), { mutualFundTransferInTableShimmer: false });
        case MUTUAL_FUNDS_TRANSFER_IN_UPDATE_FILTERS:
            return __assign(__assign({}, state), { appliedFilters: action.payload.appliedFilters });
        case MUTUAL_FUNDS_TRANSFER_IN_CLEAR_ALL_FILTERS:
            return __assign(__assign({}, state), { appliedFilters: __assign({}, JSON.parse(JSON.stringify(transferInInitialData.appliedFilters))) });
        case MUTUAL_FUNDS_TRANSFER_IN_RESET_ALL_FILTERS_AND_SEARCH:
            return __assign(__assign({}, state), { appliedFilters: __assign({}, JSON.parse(JSON.stringify(transferInInitialData.appliedFilters))) });
        default:
            return __assign({}, state);
    }
};
export default mutualFundsTransferInReducer;
